import React from 'react'
import ReactDOM from 'react-dom'
import TagBox from './TagBox'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import '../css/searchbox.css'

export default class SearchBox extends React.Component {
  constructor(props) {
    super(props)
    this.queryRef = React.createRef()
    this.categoryRef = React.createRef()
    this.trackerRef = React.createRef()
    this.favoriteRef = React.createRef()
    this.state = {
      categoryChoice: '0',
      publicChoice: '0',
      tagsFromTagBox: [],
      favoriteNotif: [],
    }
  }

  handleChange(event) {
    this.setState({categoryChoice: event.target.value})
  }

  handleTrackerChange(event) {
    this.setState({trackerChoice: event.target.value})
  }

  launchSearch() {
    const initialQuery = this.queryRef.current.value
    const category = this.categoryRef.current.value
    const tracker = this.trackerRef.current.value
    let query = initialQuery
    if (this.state.tagsFromTagBox.length) {
      query = initialQuery + ' ' + this.state.tagsFromTagBox.join(' ')
    }
    // empty query will trigger a wide search
    if (initialQuery === '') {
      this.props.search('', category, tracker)
    } else {
      this.props.search(query, category, tracker)
    }
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      this.launchSearch()
    }
  }

  addFavorite() {
    let query = this.queryRef.current.value
    let cid = this.categoryRef.current.value
    this.props.addFavorite(query, cid, this.state.tagsFromTagBox, (result) => {
      if (result) {
        this.setState({favoriteNotif: ['OK!']})
      } else {
        this.setState({favoriteNotif: ['FAILED :-(']})
      }
      setTimeout(() => {
        this.setState({favoriteNotif: []})
      }, 2000)
    })
  }

  tagsChange(notifiedTags) {
    let updatedTags = []
    notifiedTags.forEach(function (tagData) {
      if (updatedTags.indexOf(tagData.text) === -1) {
        updatedTags.push(tagData.text)
      }
    })
    this.setState({tagsFromTagBox: updatedTags})
  }

  render() {
    return (
      <div>
        <div className="from-group form-inline">
          <input type="text" ref={this.queryRef} className="form-control" onKeyDown={this.handleKeyDown.bind(this)} />
          <select ref={this.categoryRef} className="form-control" value={this.state.categoryChoice} onChange={this.handleChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}>
            <option value="All">Toutes catégories</option>
            <option value="Audio">Audio</option>
            <option value="eBook">eBook</option>
            <option value="Emulation">Emulation</option>
            <option value="Jeu vidéo">Jeu vidéo</option>
            <option value="GPS">GPS</option>
            <option value="Application">Application</option>
            <option value="Film/Vidéo">Film/Vidéo</option>
            <option value="Série">Série</option>
            <option value="xXx">xXx</option>
          </select>
          <select ref={this.trackerRef} className="form-control" value={this.state.trackerChoice} onChange={this.handleTrackerChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}>
            <option value="yggtorrent">YggTorrent</option>
            <option value="public">Trackers publiques</option>
          </select>
          <input type="submit" className="btn btn-primary" onClick={this.launchSearch.bind(this)} value="Rechercher" />
          <input type="submit" ref={this.favoriteRef} className="btn btn-danger" onClick={this.addFavorite.bind(this)} value="Ajouter aux favoris" />
          <TransitionGroup component="div">
            {this.state.favoriteNotif.map((item, i) => (
              <CSSTransition
                key={item}
                classNames="favorite-notif"
                timeout={{ enter: 300, exit: 500 }}>
                <div className="form-group">{item}</div>
              </CSSTransition>
            ))}
          </TransitionGroup>
        </div>
        <TagBox notifyParent={this.tagsChange.bind(this)} />
      </div>
    )
  }
}
